// extracted by mini-css-extract-plugin
export var equalColumn = "_iw-0";